import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from "react-router-dom"
import styles from './MainBadgeTemplateStyling.module.css'
import { useReactToPrint } from 'react-to-print'

// ------ Components ------ //
import BadgeProperty from "../../../components/Badging/MainBadgeTemplateStyling/BadgeProperty"
import StylingFormField from "../../../components/Badging/MainBadgeTemplateStyling/StylingFormField"
import PrintPageSinglePrint from '../../../components/Badging/PrintPageSinglePrint'
import SearchBar from "../../../components/Miscellaneous/SearchBar"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'
// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'

// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquarePlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons'

// ------ Image Elements ------ //
const plus = <FontAwesomeIcon icon={faSquarePlus} />
const minus = <FontAwesomeIcon icon={faSquareMinus} />

const MainBadgeTemplateStyling = () => {

    // Make form of CSS properties (font size, style, margin, etc)
    // Create a CSS object in state with default or null CSS values for all these properties
    // Have the form overwrite this object
    // Have a UI copy of this object below the form (for developer purposes) that will directly update that object in state

    // State
    const [printData, setPrintData] = useState([])
    const [badgeDimensions, setBadgeDimensions] = useState({
        width: "300px",
        height: "400px",
    })
    const [badgeOrientations, setBadgeOrientations] = useState({
        onePage: false,
        upsideDown: false,
        margin: "120px 0 0 0",
        padding: "0 0 0 0",
        textAlign: "center",
        display: "table",
        position: "relative",
        transform: "none"
    })
    const [stylingForm, setStylingForm] = useState()
    const [CSSValues, setCSSValues] = useState()
    const [specialCSSRules, setSpecialCSSRules] = useState({
        FirstNameSmaller: {
            active: false,
            length: 100,
        },
        FirstNameSmallest: {
            active: false,
            length: 100,
        },
        LastNameSmaller: {
            active: false,
            length: 100,
        },
        LastNameSmallest: {
            active: false,
            length: 100,
        },
        OrganizationSmaller: {
            active: false,
            length: 100,
        },
        OrganizationSmallest: {
            active: false,
            length: 100,
        }
    })
    const [dataStorage, setDataStorage] = useState([])
    const [stylingFieldNameFilter, setStylingFieldNameFilter] = useState("")
    const [stylingCSSNameFilter, setStylingCSSNameFilter] = useState("")
    const [isFieldNameCleared, setIsFieldNameCleared] = useState(false)
    const [isCSSNameCleared, setIsCSSNameCleared] = useState(false)
    const [badgeSettingsHidden, setBadgeSettingsHidden] = useState(false)
    const [badgeFieldsHidden, setBadgeFieldsHidden] = useState(false)
    const [badgeOrientationHidden, setBadgeOrientationHidden] = useState(false)
    const [CSSHidden, setCSSHidden] = useState(false)
    const [printAreaDimensions, setPrintAreaDimensions] = useState("4x4")
    const [stylingFormExpandableFields, setStylingFormExpandableFields] = useState([
        "firstname",
        "lastname",
        "organization"
    ])
    const [loaded, setLoaded] = useState(false)
    const [saveBody, setSaveBody] = useState({})
    const [fieldOrdering, setFieldOrdering] = useState({})
    const [registrantPrintSettings, setRegistrantPrintSettings] = useState()
    const [registrants, setRegistrants] = useState([])
    const [stylingFormFieldsArray, setStylingFormFieldsArray] = useState(stylingForm ? Object.keys(stylingForm) : [])
    const [cSSFormValuesArray, setCSSFormValuesArray] = useState(CSSValues ? Object.keys(CSSValues) : [])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const [barcodeImage, setBarcodeImage] = useState("")
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(true)
    // Constants
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const clientEventInfoRef = useRef(null)

    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    // ------ Styling Form: Badge Field Search ------ //
    const stylingFormFieldFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        stylingFormFieldsArray.forEach((field) => {
            const name = field.toLowerCase()

            if (!filterString || name.includes(filterString)) {
                filtered.push(field)
            }
        })
        return filtered
    }
    const filteredByNameSFF = stylingFormFieldsArray && stylingFormFieldsArray.length ? stylingFormFieldFilter(stylingFieldNameFilter) : []

    // ------ Styling Form: CSS Values Search ------ //
    const stylingCSSValuesFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        cSSFormValuesArray.forEach((field) => {
            const name = field.toLowerCase()

            if (!filterString || name.includes(filterString)) {
                filtered.push(field)
            }
        })
        return filtered
    }

    const filteredByCSSValueSFF = cSSFormValuesArray && cSSFormValuesArray.length ? stylingCSSValuesFilter(stylingCSSNameFilter) : []

    // Functions
    const handleChange = e => {
        let temp = stylingForm;
        if (temp) {
            //update entry
            temp[e.target.name] = e.target.value;
        }
        setStylingForm(temp)
        let regTemp = [
            temp
        ]
        setRegistrants(regTemp)
    }

    const handleBadgeDimensionChange = e => {
        setBadgeDimensions({
            ...badgeDimensions,
            [e.target.name]: e.target.value,
        })
    }

    const handleOrientationChange = e => {
        if (e.target.type === 'checkbox') {
            if (e.target.name === 'upsideDown') {
                badgeOrientations.transform = e.target.checked ? 'scale(-1, -1)' : 'none'
            }
            setBadgeOrientations({
                ...badgeOrientations,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setBadgeOrientations({
                ...badgeOrientations,
                [e.target.name]: e.target.value,
            })
        }
    }

    const handleSpecialCSSRulesChange = (badgeProp, ruleProp, value) => {
        setSpecialCSSRules({
            ...specialCSSRules,
            [badgeProp]: {
                ...specialCSSRules[badgeProp],
                [ruleProp]: value,
            }
        })
    }

    const handleCSSChange = (badgeProp, cssProp, value) => {
        setCSSValues({
            ...CSSValues,
            [badgeProp]: {
                ...CSSValues[badgeProp],
                [cssProp]: value,
            }
        })
        
    }

    // useEffect - Set Print Data
    useEffect(() => {
        if (CSSValues && CSSValues !== {} &&
            specialCSSRules && specialCSSRules !== {} &&
            fieldOrdering && fieldOrdering.length > 0) {
            let regPrintSettings = {
                cSSValues: CSSValues,
                specialCSSRules: specialCSSRules,
                fieldOrdering: fieldOrdering
            }
            setRegistrantPrintSettings(regPrintSettings)
        }

    }, [CSSValues, specialCSSRules, fieldOrdering])

    const handleSubmit = async e => {

        e.preventDefault()
        try {
            //console.log(compileForms())
            let formData = compileForms()
            await badgeService.saveMainTemplate(formData)
            navigate('/ExtraBadgeManager', { state: clientEventInfo })
        } catch (err) {
            console.log(err.message)
        }
    }

    const handleSave = async e => {

        e.preventDefault()
        try {
            //console.log(compileForms())
            let formData = compileForms()
            await badgeService.saveMainTemplate(formData)
        } catch (err) {
            console.log(err.message)
        }
    }

    const handleDimensionChange = e => {        
        setPrintAreaDimensions(e.target.value)

        if (e.target.value === '3x3') setBadgeDimensions({
            width: "300px",
            height: "300px",
        })
        else if (e.target.value === '3x4') setBadgeDimensions({
            width: "300px",
            height: "400px",
        })
        else if (e.target.value === '4x4') setBadgeDimensions({
            width: "400px",
            height: "400px",
        })
        else if (e.target.value === '4x6') setBadgeDimensions({
            width: "400px",
            height: "600px",
        })
        else if (e.target.value === '4x12') setBadgeDimensions({
            width: "400px",
            height: "1200px",
        })
    }

    const compileForms = () => {
        const compiled = {}
        compiled.clientId = clientEventInfo.clientId
        compiled.eventId = clientEventInfo.eventId
        compiled.templateName = 'Main'
        // modify so that they are strings
        compiled.badgeOrientations = badgeOrientations ? JSON.stringify(badgeOrientations) : null
        compiled.BadgeDimensions = badgeDimensions ? JSON.stringify(badgeDimensions) : null
        compiled.StylingForm = stylingForm ? JSON.stringify(stylingForm) : null
        compiled.CssValues = CSSValues ? JSON.stringify(CSSValues) : null
        compiled.SpecialCSSRules = specialCSSRules ? JSON.stringify(specialCSSRules) : null
        return compiled
    }

    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }

    // React-to-Print
    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Badge Styling - Print Preview",
        removeAfterPrint: true,

        /*onAfterPrint: () => alert("Print Success")*/
    })
    

    const getPropName = function (obj, propname) {
        var key = this;
        for (key in obj) {
            if (key.toLowerCase() === propname.toLowerCase()) {
                let str = key.toString()
                //return str.charAt(0).toUpperCase() + str.slice(1)
                return str
            }
        }
    }

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])

    // Refactored useEffect for Setting Styling Form Data
    useEffect(() => {
        const initializeStylingData = async (getReqBody, badgeFields, savedItems) => {
            const savedBadgeOrientations = savedItems?.badgeOrientations ? JSON.parse(savedItems.badgeOrientations) : null;
            const savedStylingForm = savedItems?.stylingForm ? JSON.parse(savedItems.stylingForm) : null;
            const savedCssValues = savedItems?.cssValues ? JSON.parse(savedItems.cssValues) : null;
            const savedBadgeDimensions = savedItems?.badgeDimensions ? JSON.parse(savedItems.badgeDimensions) : badgeDimensions;
            const savedSpecialCssRules = savedItems?.specialCSSRules ? JSON.parse(savedItems.specialCSSRules) : specialCSSRules;

            //console.log(savedBadgeOrientations)
            //console.log(savedStylingForm)
            //console.log(savedCssValues)
            //console.log(savedBadgeDimensions)
            //console.log(savedSpecialCssRules)

            setBadgeOrientations(savedBadgeOrientations);
            setStylingForm(savedStylingForm);
            setStylingFormFieldsArray(savedStylingForm ? Object.keys(savedStylingForm) : []);
            setRegistrants([savedStylingForm || {}]);
            setCSSValues(savedCssValues);
            setCSSFormValuesArray(savedCssValues ? Object.keys(savedCssValues) : []);
            setBadgeDimensions(savedBadgeDimensions);
            setSpecialCSSRules(savedSpecialCssRules);

            const fieldOrdering = await badgeService.getRegFieldsOrdering(getReqBody);
            setFieldOrdering(Array.from(fieldOrdering));

            const stylingFormObj = generateStylingFormObj(badgeFields, savedStylingForm);
            const cssObj = generateCSSObj(badgeFields, savedCssValues);

            //if (!savedStylingForm) {
            //    setStylingForm(stylingFormObj);
            //    setRegistrants([stylingFormObj]);
            //    setStylingFormFieldsArray(Object.keys(stylingFormObj));
            //}

            //if (!savedCssValues) {
            //    setCSSValues(cssObj);
            //    setCSSFormValuesArray(Object.keys(cssObj));
            //}

            setStylingForm(stylingFormObj);
            setRegistrants([stylingFormObj]);
            setStylingFormFieldsArray(Object.keys(stylingFormObj));
            setCSSValues(cssObj);
            setCSSFormValuesArray(Object.keys(cssObj));

            setRegistrantPrintSettings({
                cSSValues: savedCssValues || cssObj,
                specialCSSRules: savedSpecialCssRules,
                fieldOrdering: Array.from(fieldOrdering),
            });
        };     

        const generateStylingFormObj = (badgeFields, savedStylingForm) => {
            const defaultValues = {
                FirstName: "John",
                LastName: "Doe",
                Organization: "Smithbucklin",
                RegistrationType: "Exhibitor",
                City: "Chicago",
                State: "IL",
            };

            return badgeFields.reduce((acc, field) => {
                const fieldName = field.name;
                const value = savedStylingForm?.[getPropName(savedStylingForm, fieldName)] || defaultValues[fieldName] || "";
                acc[fieldName] = value;
                return acc;
            }, {});
        };

        const generateCSSObj = (badgeFields, savedCssValues) => {
            const defaultCSS = {
                // First Name
                FirstName: { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "" },
                FirstNameSmaller: { fontSize: "20px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "" },
                FirstNameSmallest: { fontSize: "16px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "" },
                // Last Name
                LastName: { fontSize: "32px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                LastNameSmaller: { fontSize: "28px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                LastNameSmallest: { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                // Organization
                Organization: { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                OrganizationSmaller: { fontSize: "20px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                OrganizationSmallest: { fontSize: "16px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                // Rest
                RegistrationType: { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "600" },
                CityState_Combo: { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0", fontWeight: "" },
                ScannerField: { width: "200px", margin: "0 0 5px 0", padding: "0", }, 
                ScannerImage: { width: "200px", margin: "0 0 5px 0", padding: "0", }, 
            };

            return badgeFields.reduce((acc, field) => {
                const fieldName = field.name;
                acc[fieldName] = savedCssValues?.[fieldName] || defaultCSS[fieldName] || "";
                return acc;
            }, {});
        };

        const fetchData = async () => {
            try {
                const getReqBody = await createRequestBody();
                const badgeFields = await badgeService.getEventBadgeFieldOptionsWithRanking(getReqBody);
                const savedItems = await badgeService.getMainTemplate(getReqBody);

                await initializeStylingData(getReqBody, badgeFields, savedItems);
                setLoaded(true)
            } catch (error) {
                console.error("Error fetching EventBadgeFields JSON: ", error);
                resetStylingState();
            }
        };

        const resetStylingState = () => {
            setStylingForm(null);
            setStylingFormFieldsArray([]);
            setRegistrants([]);
            setLoaded(true);
        };

        if (clientEventInfo?.clientId !== undefined && clientEventInfo.clientName) {
            fetchData();
        }
    }, [clientEventInfo]);

    //// No longer used as image now being included with attendee object retrieval
    //useEffect(() => {
    //    const fetchImage = async () => {
    //        if (registrantPrintSettings) {
    //            const image = await getScannerImage();
    //            setBarcodeImage(image);
    //        }
    //        setLoaded(true)
    //    };

    //    fetchImage();
    //}, [registrantPrintSettings])

    return (
        <div className={loaded ? styles.printPage : ""}>
            {
                loaded ?
                    <>
                        <h1>Template Styling - Main Badge</h1>
                        <br />
                        <label htmlFor="printDimensionSelect">Set Badge Dimensions: </label>
                        <select
                            name="printDimensionSelect"
                            id={styles.dimensionSelect}
                            onChange={e => handleDimensionChange(e)}
                        >
                            <option value="3x4" selected="selected">3x4</option>
                            <option value="4x4">3x3</option>
                            <option value="4x4">4x4</option>
                            <option value="4x6">4x6</option>
                            <option value="4x12">4x12</option>
                        </select>
                        <br /> <br />
                        <BackSaveContinueButton
                            continueButtonVisibility={continueButtonVisibility}
                            handleSaveAndNavigate={handleSubmit}
                            handleSave={handleSave}
                            styles={styles}
                            navigate={navigate}
                        />
                        <br />
                        <div id={styles.MTSContainer}>

                            <div id={styles.formSection}>
                                <h2 id={styles.inputHeader} onClick={() => setBadgeOrientationHidden(!badgeOrientationHidden)}>
                                    Badge Orientation {badgeOrientationHidden ? plus : minus}
                                </h2>
                                {!badgeOrientationHidden ?
                                    <div id={styles.stylingFormArea}>
                                        <form
                                            autoComplete="off"
                                            onSubmit={handleSubmit}
                                            id={styles.stylingForm}
                                        >
                                            <label htmlFor="onePage" className={styles.label} title='Print main and extra badge on one template.'
                                            >Print One Page For All:</label>

                                            <input
                                                type="checkbox"
                                                autoComplete="off"
                                                value={badgeOrientations.onePage}
                                                name="onePage"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />

                                            <label htmlFor="upsideDown" className={styles.label} title='Print badge upside down, oriented to printer settings.'
                                            >Print Upside Down:</label>

                                            <input
                                                type="checkbox"
                                                autoComplete="off"
                                                value={badgeOrientations.upsideDown}
                                                name="upsideDown"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />
                                            <label htmlFor="margin" className={styles.label} title='Print margin for template.'
                                            >Badge Margin:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeOrientations.margin}
                                                name="margin"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />
                                            <label htmlFor="padding" className={styles.label} title='Print padding for template.'
                                            >Badge Padding:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeOrientations.padding}
                                                name="padding"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />
                                            <label htmlFor="textAlign" className={styles.label} title='Print text-align for template.'
                                            >Badge Text Align:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeOrientations.textAlign}
                                                name="textAlign"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />
                                            <label htmlFor="display" className={styles.label} title='Print display for template.'
                                            >Badge Display:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeOrientations.display}
                                                name="display"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />

                                            <label htmlFor="position" className={styles.label} title='Print position for template.'
                                            >Badge Position:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeOrientations.position}
                                                name="position"
                                                onChange={handleOrientationChange}
                                                className={styles.formInput}
                                            />
                                        </form>
                                    </div>
                                    :
                                    <></>
                                }

                                <h2 id={styles.inputHeader} onClick={() => setBadgeSettingsHidden(!badgeSettingsHidden)}>
                                    Badge Dimensions {badgeSettingsHidden ? plus : minus}
                                </h2>

                                {!badgeSettingsHidden ?
                                    <div id={styles.stylingFormArea}>
                                        <form
                                            autoComplete="off"
                                            onSubmit={handleSubmit}
                                            id={styles.stylingForm}
                                        >
                                            <label htmlFor="width" className={styles.label}>Badge Width:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeDimensions.width}
                                                name="width"
                                                onChange={handleBadgeDimensionChange}
                                                className={styles.formInput}
                                            />

                                            <label htmlFor="height" className={styles.label}>Badge Height:</label>

                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={badgeDimensions.height}
                                                name="height"
                                                onChange={handleBadgeDimensionChange}
                                                className={styles.formInput}
                                            />
                                        </form>
                                    </div>
                                    :
                                    <></>
                                }

                                <h2 id={styles.inputHeader} onClick={() => setBadgeFieldsHidden(!badgeFieldsHidden)}>
                                    Badge Fields {badgeFieldsHidden ? plus : minus}
                                </h2>

                                {!badgeFieldsHidden ?
                                    <div id={styles.stylingFormArea}>
                                        <SearchBar
                                            searchName={stylingFieldNameFilter}
                                            handleSearchName={setStylingFieldNameFilter}
                                            placeholder="Field Name"
                                            label="Name"
                                            includeClearButton={true}
                                            isCleared={isFieldNameCleared}
                                            setIsCleared={setIsFieldNameCleared}
                                            styles={styles}
                                        />
                                        <form
                                            autoComplete="off"
                                            onSubmit={handleSubmit}
                                            id={filteredByNameSFF.length ? styles.stylingForm : styles.hideStylingForm}
                                        >
                                            {filteredByNameSFF.length ?
                                                filteredByNameSFF.map((property, index) => (
                                                    <StylingFormField
                                                        key={index}
                                                        property={property}
                                                        styles={styles}
                                                        stylingForm={stylingForm}
                                                        handleChange={handleChange}
                                                        stylingFormExpandableFields={stylingFormExpandableFields}
                                                        specialCSSRules={specialCSSRules}
                                                        handleSpecialCSSRulesChange={handleSpecialCSSRulesChange}
                                                    />
                                                ))
                                                :
                                                <div>
                                                    No matching results
                                                </div>
                                            }
                                        </form>
                                    </div>
                                    :
                                    <></>
                                }

                                <h2 id={styles.inputHeader} onClick={() => setCSSHidden(!CSSHidden)}>
                                    CSS Values {CSSHidden ? plus : minus}
                                </h2>

                                {!CSSHidden ?
                                    <div id={styles.stylingFormArea}>
                                        <SearchBar
                                            searchName={stylingCSSNameFilter}
                                            handleSearchName={setStylingCSSNameFilter}
                                            placeholder="CSS Field Name"
                                            label="Name"
                                            includeClearButton={true}
                                            isCleared={isCSSNameCleared}
                                            setIsCleared={setIsCSSNameCleared}
                                            styles={styles}
                                        />
                                        {filteredByCSSValueSFF.length ?
                                            filteredByCSSValueSFF.map((badgeProperty, index) => (
                                                <BadgeProperty
                                                    badgeProperty={badgeProperty}
                                                    index={index}
                                                    CSSValues={CSSValues}
                                                    onCSSChange={(cssProp, value) => handleCSSChange(badgeProperty, cssProp, value)}
                                                />
                                            ))
                                            :
                                            <div className={styles.noMatchingResults}>
                                                No matching results
                                            </div>
                                        }
                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                            {badgeDimensions && fieldOrdering && registrantPrintSettings ?
                                <div className={styles.printArea}
                                    style={{
                                        width: badgeDimensions.width, height: badgeDimensions.height, margin: badgeOrientations.margin,
                                        padding: badgeOrientations.padding, textAlign: badgeOrientations.textAlign, display: badgeOrientations.display,
                                        position: badgeOrientations.position
                                    }}>
                                    <PrintPageSinglePrint
                                        clientEventInfo = {clientEventInfo}
                                        badgeDimensions={badgeDimensions}
                                        badgeOrientations={badgeOrientations}
                                        registrant={registrants}
                                        registrantPrintSettings={registrantPrintSettings}
                                        barcodeImage={barcodeImage}
                                        componentRef={componentRef}
                                    />
                                    <button className={styles.printForm} id={styles.printButton} onClick={handlePrint}>
                                        Print
                                    </button>
                                </div>

                                : <></>}


                        </div>
                        <br /> <br />
                        <BackSaveContinueButton
                            continueButtonVisibility={continueButtonVisibility}
                            handleSaveAndNavigate={handleSubmit}
                            handleSave={handleSave}
                            styles={styles}
                            navigate={navigate}
                        />
                        <br />
                    </>
                    :
                    <LoadingSpinner />
            }
        </div>
    );
}

export default MainBadgeTemplateStyling